const { requestManager } = require('../../requestManager');

const { API_PATH } = require('../../config/config');

class RsvScnMastaApi {
  /**
   * 予約画面マスタ取得
   * @param {number} rsvMode 予約モード
   * @param {number} purpose 用途
   * @return {Promise<Array>} 予約画面リスト
   */
  getRsvScn = async (rsvMode, purpose) => {
    const params = { rsvMode, purpose };
    const result = await requestManager.get(`${API_PATH}/masta/rsvScn/r`, params);
    return result.data;
  };
}

export default new RsvScnMastaApi();
